import { history as historyRouter } from 'instantsearch.js/es/lib/routers';

// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
function getCategorySlug(name) {
    return name.split(' ').map(encodeURIComponent).join('+');
}

// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
function getCategoryName(slug) {
    return slug.split('+').map(decodeURIComponent).join(' ');
}

const search = document.querySelector('.roam-search');

function getSectionName() {
    return search.dataset.section;
}

function getHubName() {
    return search.dataset.hub;
}

const ORIGINAL_TITLE = document.title;

export const routing = (indexName) => ({
    router: historyRouter({
        windowTitle({ category, query }) {
            if (!category && !query) return ORIGINAL_TITLE;

            const queryTitle = query ? `Results for "${query}"` : 'Search';

            if (category) {
                return `${category} – ${queryTitle}`;
            }

            return queryTitle;
        },

        createURL({ qsModule, routeState, location }) {
            const urlParts = location.href.match(/^(.*?)\/${getSectionName()}/);
            const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

            const queryParameters = {};

            const categoryPath = routeState.category
                ? `${getCategorySlug(routeState.category)}/`
                : '';

            if (routeState.region) {
                queryParameters.region = encodeURIComponent(routeState.region);
            }

            if (routeState.query) {
                queryParameters.query = encodeURIComponent(routeState.query);
            }

            if (routeState.page !== 1) {
                queryParameters.page = routeState.page;
            }

            if (routeState.region) {
                queryParameters.region = routeState.region;
            }

            const queryString = qsModule.stringify(queryParameters, {
                addQueryPrefix: true,
                arrayFormat: 'repeat'
            });

            return `${baseUrl}${getSectionName()}/${categoryPath}${queryString}`;
        },

        parseURL({ qsModule, location }) {
            const regex = new RegExp(getSectionName() + '/(.*?)/?$');
            const pathnameMatches = location.pathname.match(regex);
            const category = getCategoryName((pathnameMatches && pathnameMatches[1]) || '');
            const { query = '', page, region } = qsModule.parse(location.search.slice(1));
            // `qs` does not return an array when there's a single value.

            return {
                query: decodeURIComponent(query),
                page,
                category,
                region
            };
        }
    }),

    stateMapping: {
        stateToRoute(uiState) {
            const indexUiState = uiState[indexName] || {};

            return {
                query: indexUiState.query,
                page: indexUiState.page,
                region: indexUiState.menu && indexUiState.menu['roam_products_regions.lvl0'],
                category:
                    indexUiState.hierarchicalMenu &&
                    indexUiState.hierarchicalMenu['roam_products_categories.lvl0'].join('>')
            };
        },

        routeToState(routeState) {
            return {
                [`deals_${getHubName()}`]: {
                    query: routeState.query,
                    page: routeState.page,
                    menu: {
                        'roam_products_regions.lvl0': routeState.region
                    },
                    hierarchicalMenu: {
                        'roam_products_categories.lvl0': routeState.category.split('>')
                    }
                },
                [`products_${getHubName()}`]: {
                    query: routeState.query,
                    page: routeState.page,
                    menu: {
                        'roam_products_regions.lvl0': routeState.region
                    },
                    hierarchicalMenu: {
                        'roam_products_categories.lvl0': routeState.category.split('>')
                    }
                },
                [`pages_${getHubName()}`]: {
                    query: routeState.query,
                    page: routeState.page
                }
            };
        }
    }
});
